import React, { useRef } from 'react';
import { Upload, FileUp } from 'lucide-react';

interface CsvImporterProps {
  onImport: (data: string[][]) => void;
  label?: string;
}

export const CsvImporter: React.FC<CsvImporterProps> = ({ onImport, label = "Import CSV" }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target?.result as string;
      if (!text) return;

      // Simple CSV parser handling quotes
      const rows = text.split('\n').filter(row => row.trim() !== '');
      const parsedData = rows.map(row => {
        // Split by comma, but ignore commas inside quotes
        const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
        return row.split(regex).map(cell => {
          // Remove surrounding quotes if present
          return cell.trim().replace(/^"|"$/g, '').trim();
        });
      });

      onImport(parsedData);
      
      // Reset input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    };
    reader.readAsText(file);
  };

  return (
    <>
      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
      />
      <button
        onClick={() => fileInputRef.current?.click()}
        className="bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 px-4 py-2 rounded-lg flex items-center gap-2 transition-colors shadow-sm text-sm font-medium"
      >
        <FileUp size={18} />
        {label}
      </button>
    </>
  );
};